<template>
	<div class="tiptap-blur-source flex items-center">
		<FloatingElement
			placement="bottom-start"
		>
			<template #trigger>
				<div
					class="
						won-tag-light-gray flex h-6 w-[30px] cursor-pointer items-center
						justify-center select-none
					"
				>
					<TextSizeIcon />
				</div>
			</template>

			<div class="rounded bg-white shadow-card">
				<div
					v-for="(lh, index) in LINE_HEIGHT_OPTIONS"
					:key="index"
					class="cursor-pointer py-3 pr-3 pl-2 text-base text-won-black hover:bg-won-sand-light"
					@click="() => setLineHeight(lh.value)"
				>
					<div class="flex items-center gap-3">
						<CheckIcon
							class="size-4 text-won-blue"
							:class="lh.value === lineHeight ? 'opacity-100' : 'opacity-0'"
						/>

						<span> {{ lh.title }} </span>
					</div>
				</div>

				<hr class="my-2" />

				<div
					class="cursor-pointer py-3 pr-3 pl-2 text-base text-won-black hover:bg-won-sand-light"
					@click="showCustomLineHeight"
				>
					<div class="flex items-center gap-3">
						<CheckIcon
							class="size-4 text-won-blue"
							:class="!LINE_HEIGHT_VALUES.includes(lineHeight) ? 'opacity-1' : 'opacity-0'"
						/>

						<span>Custom spacing</span>
					</div>
				</div>
			</div>
		</FloatingElement>

		<CustomLineHeight
			:show-modal="isCustomLineHeightVisible"
			:close-modal="hideCustomLineHeight"
		/>
	</div>
</template>

<script setup>
import { ref } from 'vue';
import { storeToRefs } from 'pinia';
import { CheckIcon } from '@heroicons/vue/24/solid';
import { useBuilderStyles } from '../../store/builder-style.store';
import { useTiptapStore } from '../../store/tiptap.store';

import TextSizeIcon from '../../icons/pdf-actions/text-size.vue';
import FloatingElement from '../library/floting-element.vue';

const LINE_HEIGHT_OPTIONS = [
	{ title: 'Single', value: 1 },
	{ title: '1.15', value: 1.15 },
	{ title: '1.5', value: 1.5 },
	{ title: 'Double', value: 2 },
];

const LINE_HEIGHT_VALUES = [1, 1.15, 1.5, 2];

const isCustomLineHeightVisible = ref(false);

const builderStyle = useBuilderStyles();
const tiptapStore = useTiptapStore();

const { isFocused, editor } = storeToRefs(tiptapStore);
const { lineHeight } = storeToRefs(builderStyle);

const showCustomLineHeight = () => {
	isCustomLineHeightVisible.value = true;
};

const hideCustomLineHeight = () => {
	isCustomLineHeightVisible.value = false;
};

const setLineHeight = (lh) => {
	if (isFocused.value === false) {
		builderStyle.setLineHeight(lh);
		return;
	}

	editor.value.chain().focus().setLineHeight(lh).run();
};
</script>
